import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/user`;

export const fetchUsersByCompanyApi = async () => {
  const response = await axios.get(API_BASE_URL);
  return response;
};

export const addNewUserApi = async (userData) => {
  const response = await axios.post(API_BASE_URL, userData);
  return response;
};

export const editUserApi = async (userData) => {
  const response = await axios.put(API_BASE_URL, userData);
  return response;
};

export const fetchCompanyUsersApi = async (companyid) => {
  const body = { companyID: companyid };
  const response = await axios.post(`${API_BASE_URL}/fetchCompanyUsers`, body);
  return response;
};

export const fetchCollectionUsersApi = async (collectionID) => {
  const body = { collectionID: collectionID };
  const response = await axios.post(`${API_BASE_URL}/fetchCollectionUsers`, body);
  return response;
};

export const addUserToCollectionApi = async (data) => {
  const body = { collectionID: data.collectionID, userID: data.userID };
  const response = await axios.post(`${API_BASE_URL}/addUserToCollection`, body);
  return response;
};

export const removeUserFromCollectionApi = async (data) => {
  const body = { collectionID: data.collectionID, userID: data.userID };
  const response = await axios.post(`${API_BASE_URL}/removeUserFromCollection`, body);
  return response;
};

export const sendResetPasswordApi = async (userid) => {
  const body = { userID: userid };
  const response = await axios.post(`${API_BASE_URL}/reset-password-email`, body);
  return response;
};
